// extracted by mini-css-extract-plugin
module.exports = {"edith":"usersTable_edith__ct9OD","span":"usersTable_span__2uvlG","tr":"usersTable_tr__2D-LF"};